import React from 'react'
import { TWStaticAFLCard } from './TWStaticAFLCard'
import { createRegisterableComponent } from '@news-mono/web-common'

export const TWStaticAFLCardRegistration = createRegisterableComponent(
    'tw-static-alf-card',
    () => <TWStaticAFLCard />,
)
